import { IApplicationState } from '../../types/redux';

export const selectRotatingBanner = (state: IApplicationState) => state.rotatingBanner;
